import _Number$isNaN from "@babel/runtime-corejs3/core-js/number/is-nan";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { useInstance } from 'intact-vue-next';
import { useReceive } from '../../hooks/useReceive';
import { error, isNullOrUndefined, isString } from 'intact-shared';
import { useState } from '../../hooks/useState';
// const numberReg = /^(-|\+)?\d+(\.(\d+)?)?$/;
export function useValue(getStep, formatter) {
  var instance = useInstance();
  var showValue = useState(instance.get('value'));
  useReceive(['max', 'min', 'precision', 'value', 'formatter', 'parser', 'prefix', 'suffix'], function () {
    fixValue(instance.get('value'), 0);
  });
  function fixValue(value, fallbackValue) {
    var _getFixedValue = getFixedValue(value, fallbackValue),
      valueString = _getFixedValue.valueString,
      fixedValue = _getFixedValue.value;
    showValue.set(valueString);
    instance.set({
      value: fixedValue
    });
    return fixedValue;
  }
  function getFixedValue(value, fallbackValue) {
    var _instance$get = instance.get(),
      precision = _instance$get.precision,
      max = _instance$get.max,
      forceStep = _instance$get.forceStep;
    if (isString(value)) {
      value = formatter.parse(value);
    }
    if (_Number$isNaN(value)) {
      value = fallbackValue;
    }
    var _getStep = getStep(value),
      step = _getStep[0],
      min = _getStep[1];
    if (min > max) {
      if (process.env.NODE_ENV !== 'production') {
        error("[Spinner] min must less than or equal to max, but got min: " + min + " max: " + max);
      }
      return {
        valueString: formatter.format(fallbackValue),
        value: fallbackValue
      };
    }
    value = minMaxStep(value, min, max, forceStep ? step : null);
    if (!isNullOrUndefined(precision)) {
      value = +value.toFixed(precision);
    }
    var valueString = formatter.format(value);
    return {
      valueString: valueString,
      value: value
    };
  }
  // we need change value as long as the input is valid, #213
  function onInput(e) {
    var val = e.target.value;
    var _getFixedValue2 = getFixedValue(_trimInstanceProperty(val).call(val), instance.get('value')),
      value = _getFixedValue2.value;
    showValue.set(val);
    instance.set({
      value: value
    });
  }
  return {
    showValue: showValue,
    fixValue: fixValue,
    getFixedValue: getFixedValue,
    onInput: onInput
  };
}
/**
 * return max min or multiple by step
 */
export function minMaxStep(value, min, max, step) {
  if (value >= max) return max;
  if (value <= min) return min;
  if (step) {
    value = Number((Math.round((value - min) / step) * step + min).toFixed(10));
    // value = Number((Math.round(value / step) * step).toFixed(10))
    return minMaxStep(value, min, max, null);
  }
  return value;
}